import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder';

// We use placeholders to prevent the library from throwing a fatal error on initialization
// if the environment variables are missing (common on first Vercel deploy).
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
